<template>
  <div>
    <div class="step-title">{{ stepTitle }}</div>
    <progressBar :count="totalStep" :value="step" />
    <serviceBanquetStep1 v-if="step == 1" @nextStep="nextStep" />
    <serviceBanquetStep2
      v-if="step == 2"
      @previousStep="previousStep"
      @nextStep="nextStep"
    />
    <serviceBanquetStep3
      v-if="step == 3"
      @previousStep="previousStep"
      @nextStep="nextStep"
      @pay="pay"
    />
    <serviceBanquetStep4 v-if="step == 4" :orderStatus="orderStatus" />
  </div>
</template>

<script>
import store from 'Store/store';
import serviceBanquetStep1 from 'Pages/ServiceModule/ServiceBanquet/ServiceBanquetStep1.vue';
import serviceBanquetStep2 from 'Pages/ServiceModule/ServiceBanquet/ServiceBanquetStep2.vue';
import serviceBanquetStep3 from 'Pages/ServiceModule/ServiceBanquet/ServiceBanquetStep3.vue';
import serviceBanquetStep4 from 'Pages/ServiceModule/ServiceBanquet/ServiceBanquetStep4.vue';
import progressBar from 'Components/progress/progressBar.vue';

export default {
  name: 'Service2',
  components: {
    progressBar,
    serviceBanquetStep1,
    serviceBanquetStep2,
    serviceBanquetStep3,
    serviceBanquetStep4,
  },
  data() {
    return {
      totalStep: 4,
      currentStep: 1,
      stepTitles: ['服務說明', '填寫申請人資料', '確認申請內容', '付款'],
    };
  },
  mounted() {
    this.$emit('getOrderStatus');
  },
  computed: {
    enabled() {
      return store.state.main.onlineStatus.reposeInfo.enable;
    },
    step() {
      return this.currentStep;
    },
    stepTitle() {
      return this.stepTitles[this.currentStep - 1];
    },
    orderStatus() {
      return store.state.main.orderStatus;
    },
  },
  methods: {
    previousStep() {
      this.currentStep -= 1;
      window.scrollTo({ behavior: 'auto', top: 0 });
    },
    nextStep() {
      if (this.currentStep == 1 && false === this.enabled) {
        store.dispatch('main/showErrorMsg', { msg: '平安宴尚未開放' });
        return;
      }
      this.currentStep += 1;
      window.scrollTo({ behavior: 'auto', top: 0 });
    },
    showResult() {
      this.currentStep = this.totalStep;
    },
    pay(paymentInfo) {
      store.dispatch('main/bookingRepose', paymentInfo);
    },
    clearApplyInfo() {
      store.dispatch('main/clearBanquetApplyInfo');
    },
  },
};
</script>

<style scoped>
.step-title {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin: 29px 5px 10px 5px;
}
</style>
